import React from 'react';
import { useLocation } from "react-router-dom";
import './../../pg/Global.css';
import './../Palette.css';
import './PageNav.css';

type PageNavProps = {
    FrontText: string,
    Navs: string[],
};


// TODO: PageNavReturn, static button for returning to the top of page

var i = 0;
const PageNav: React.FC<PageNavProps> = ({ FrontText, Navs }) => {
    const location = useLocation();
    // With the 'Return to the top' button
    if (location.hash) {
        return (
            <div className='PageNavCompWrap'>
                <div className='PageNavTopReturnWrap'>
                    <a href={'/#' + location.pathname.substring(1) + '/' + location.search}
                    onClick={() => {
                        var o: ScrollToOptions = {};
                        o.top = 0;
                        window.scrollTo(o);
                    }}>
                        return
                    </a>
                </div>
                <div className='PageNavReturn' />
                <div className='PageNavWrapper'>
                    <ul className='PageNavUl'>
                        <li className='PageNavElementOnThisPage' key={i++}>{FrontText}</li>
                        {
                            Navs.map((nav) => {
                                return <li className='PageNavElement' key={i++} >
                                    <a href={'/#' + location.pathname.substring(1) + '/' + location.search + nav}>
                                        {nav}
                                    </a>
                                </li>
                            })
                        }
                    </ul>
                </div>
            </div>
        );
    }
    // Without the 'Return to the top' button
    else {
        return (
            <div className='PageNavCompWrap'>
                <div className='PageNavReturn' />
                <div className='PageNavWrapper'>
                    <ul className='PageNavUl'>
                        <li className='PageNavElementOnThisPage' key={i++}>{FrontText}</li>
                        {
                            Navs.map((nav) => {
                                return <li className='PageNavElement' key={i++} >
                                    <a href={'/#' + location.pathname.substring(1) + '/' + location.search + nav}>
                                        {nav}
                                    </a>
                                </li>
                            })
                        }
                    </ul>
                </div>
            </div>
        );
    }
};

export default PageNav;

